import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { TextReveal } from './ui/Reveal';
export function Hero() {
  return <section id="top" className="relative flex w-full flex-col items-center justify-center overflow-hidden bg-black px-5 pb-24 pt-32 text-center lg:min-h-[666px] lg:px-8 lg:py-0" data-id="element-103" data-mp="ehtkhzt5b7pe">
      <div className="absolute inset-0 z-0" data-id="element-104" data-mp="4jm5hmif2zq1">
        <video autoPlay loop muted playsInline className="h-full w-full object-cover opacity-40" data-id="element-105" data-mp="129qurmgy5roe">
          <source src="https://cdn.magicpatterns.com/uploads/9TzcAQCwTFtdj18kAC1CqA/2564669_Neural_Networks_1280x720.mp4" type="video/mp4" data-id="element-106" data-mp="x8bcg265lz9p" />
        </video>
        <div className="absolute inset-0 bg-black/40" data-id="element-107" data-mp="neaw145f97lo" />
      </div>

      <motion.div initial={{
      opacity: 0,
      y: 16
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6,
      ease: 'easeOut'
    }} className="relative z-10 flex flex-col items-center gap-8" data-id="element-108" data-mp="3d2ldtocrhr6i">
        <img src="https://cdn.magicpatterns.com/uploads/xd4wkhzMigGrMGUngGqM7V/Layer_1.png" alt="Illustration" className="h-10 w-auto object-contain lg:h-12" data-id="element-109" data-mp="3j9aldp7jncay" />

        <div className="flex max-w-[1036px] flex-col items-center gap-8" data-id="element-110" data-mp="39a32kmi1ipgg">
          <h1 className="t-display max-w-[18ch] text-white" data-id="element-111" data-mp="3e84n7bv46wu1">
            <TextReveal data-id="element-112" data-mp="30iawsp3yo4i7">Helping</TextReveal>{' '}
            <em className="t-serif" data-id="element-113" data-mp="30ggab6d1k4c0"><TextReveal data-id="element-114" data-mp="30g6mnpfgy99h">Brands Thrive</TextReveal></em>
            <br data-id="element-115" data-mp="359sy5e9wc73p" />
            <TextReveal data-id="element-116" data-mp="35aasu6gwud9i">in the Digital Age</TextReveal>
          </h1>

          <div className="mt-4 flex w-full flex-col items-center gap-4 sm:w-auto sm:flex-row" data-id="element-117" data-mp="2qkmv1f7xtwqj">
            <Button to="/#contact" variant="solid" data-id="element-118" data-mp="2vi55ja1lsk0n">
              Book Free Consultation
            </Button>
            <Button to="/#work" variant="outline-light" showArrow={false} data-id="element-119" data-mp="2hk85g3nxxvh8">
              See Our Work
            </Button>
          </div>
        </div>
      </motion.div>
    </section>;
}